import React from 'react';
import VideoRow from './VideoRow';
import { useAuth } from '../context/AuthContext';
import { useT } from '../utils/i18n';
import '../App.css'; // For sortable styles

const VideoTable = ({
  videos,
  sortConfig,
  requestSort,
  narrator = 'Won',
  selectedVideoIds = new Set(),
  onVideoToggleSelection = () => {},
  onSelectAllToggle = () => {},
  onRowAction = () => {},
}) => {

  const { isAdmin } = useAuth();
  const t = useT();

  const getSortArrow = (key) => {
    if (!sortConfig || sortConfig.key !== key) {
      return <span className="sort-arrow">↕</span>; // Default arrow or empty
    }
    return <span className="sort-arrow active">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
  };

  const narratorLabel = narrator === 'Won' ? 'ว่าน' : 'หวาน';
  
  const isAllSelected = videos.length > 0 && selectedVideoIds.size === videos.length;
  const isSomeSelected = selectedVideoIds.size > 0 && selectedVideoIds.size < videos.length;

  return (
    <table className="table table-striped table-hover">
      <thead>
        <tr>
          <th style={{ width: '40px' }}>
            {isAdmin && (
              <input
                type="checkbox"
                checked={isAllSelected}
                indeterminate={isSomeSelected}
                onChange={onSelectAllToggle}
                title="Select all videos on this page"
                style={{ cursor: 'pointer' }}
              />
            )}
          </th>
          <th className="sortable" onClick={() => requestSort('id')}>
            รหัส {getSortArrow('id')}
          </th>
          <th className="sortable" onClick={() => requestSort('name')}>
            ชื่อ {getSortArrow('name')}
          </th>
          <th>ความยาว</th>
          <th>ราคา ({narratorLabel})</th>
          <th className="sortable" onClick={() => requestSort('created_at')}>
            วันที่นำเข้า {getSortArrow('created_at')}
          </th>
          <th>สถานะ ({narratorLabel})</th>
          <th>{t('Actions')}</th>
        </tr>
      </thead>
      <tbody>
        {videos.length > 0 ? (
          videos.map((video) => (
            <VideoRow
              key={video.id}
              video={video}
              narrator={narrator}
              isSelected={selectedVideoIds.has(video.id)}
              onToggleSelection={onVideoToggleSelection}
              onAction={onRowAction}
            />
          ))
        ) : (
          <tr>
            <td colSpan="8" className="text-center">{t('No videos found.')}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

// Memoized so a parent state change (e.g. an optimistic single-row patch) does
// not re-run the whole row map; combined with React.memo on VideoRow, only the
// changed rows re-render.
export default React.memo(VideoTable);